import { render, staticRenderFns } from "./OrthoPainCharacteristics.vue?vue&type=template&id=7096b87e&scoped=true"
import script from "./OrthoPainCharacteristics.vue?vue&type=script&lang=js"
export * from "./OrthoPainCharacteristics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7096b87e",
  null
  
)

export default component.exports